import { useCurrentBrandPlan } from 'hooks/queries/brandPlans/useCurrentBrandPlan'
import { useFlipperFlag } from 'hooks/useFlipperFlag'

export const getIsAvatarVideoAvailable = (
  avatarVideosEnabled: boolean,
  isStrictBrandControl: boolean,
  hasContentStrategies: boolean,
): boolean => avatarVideosEnabled && !isStrictBrandControl && hasContentStrategies

export const useIsAvatarVideoAvailable = (): boolean => {
  const avatarVideosEnabled = useFlipperFlag('ai_avatar_videos')
  const { data: brandPlan } = useCurrentBrandPlan()
  const isStrictBrandControl = brandPlan?.brand_kit?.strict_brand_control ?? false
  const hasContentStrategies = brandPlan?.has_content_strategies ?? false

  return getIsAvatarVideoAvailable(avatarVideosEnabled, isStrictBrandControl, hasContentStrategies)
}
